<template>
  <ul class="flex bg-hqPurple100 border rounded-sm border-hqPurple300 box-border w-fit">
    <li v-for="(item, index) in options" :key="item">
      <label
        class="px-4 py-1 inline-block rounded-sm"
        :class="[(modelValue !== item.value && 'text-hqPurple300 ') || '!text-hqPurple bg-white']"
      >
        <input
          type="checkbox"
          @input="$emit('update:modelValue', item.value)"
          class="hidden"
          :id="item.label + index"
          :required="required"
          :disabled="disabled"
        />
        {{ item.label }}
      </label>
    </li>
  </ul>
</template>

<script setup>
defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  options: {
    type: Array,
    default: () => [],
  },
  required: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
defineEmits(["update:modelValue"]);
</script>
